import CourseItem from "./CourseItem";

export default CourseItem;
